import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface MapState {
    mapName: string;
    center: [number, number];
    mapLayer: string[]
}

const initialState: MapState = {
    mapName: 'Google',
    center: [30.438889032647904, 47.34751085026624],
    mapLayer: ['Pipelines', 'Skid Status']
};

const mapSlice = createSlice({
    name: 'map',
    initialState,
    reducers: {
        setMapInfo: (state, action: PayloadAction<Partial<MapState>>) => {
            return { ...state, ...action.payload };
        },

        setMapLayer: (state, action: PayloadAction<{ name: string, type: 'overlayadd' | 'overlayremove' }>) => {
            const { name, type } = action.payload

            if (type === 'overlayadd') {
                return { ...state, mapLayer: [...state.mapLayer, name] };
            } else if (type === 'overlayremove') {
                return { ...state, mapLayer: state.mapLayer.filter(layer => layer !== name) };
            }
            return state; // Return the current state if no changes are made
        },
    },
});

export const { setMapInfo, setMapLayer } = mapSlice.actions;
export default mapSlice.reducer;